import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { dashApiInterceptorSetup } from '../main/support/dash_api';
import { serverReduxSetup } from '../main/support/server';
import AccessControl from '../main/reducers/AccessControlReducer';
import AdLinks from './domains/AdLinks/AdLinks.reducer';
import AdPartner from './domains/AdPartner/AdPartner.reducer';
import AgencyRelationshipReducer from '../main/reducers/AgencyRelationshipReducer';
import AppReducer from '../common/reducers/AppReducer';
import AppStoreReducer from './domains/AppStore/AppStore.reducer';
import AuthServiceReducer from '../main/reducers/AuthServiceReducer';
import BillingAccount from '../main/reducers/BillingAccountReducer';
import BranchAccountReducer from './domains/BranchAccount/BranchAccount.reducer';
import Cnames from '../main/reducers/CnamesReducer';
import Collection from '../main/reducers/CollectionReducer/CollectionReducer';
import DataIntegrations from '../main/reducers/DataIntegrationsReducer';
import DomainLinks from '../main/reducers/DomainLinksReducer';
import EmailOnboarding from '../main/reducers/EmailOnboarding';
import Facebook from '../main/reducers/FacebookReducer';
import FlipperUpdates from './domains/FlipperUpdates/Flipper.reducer';
import Google from '../main/reducers/GoogleReducer';
import GoogleMarketingPlatform from './domains/AdPartner/Google/MarketingPlatform/GoogleMarketingPlatform.reducer';
import GoogleAds from './domains/AdPartner/Google/Ads/GoogleAds.reducer';
import Invoices from '../main/reducers/InvoicesReducer';
import JourneyReducer from '../main/reducers/JourneyReducer';
import Deepview from '../main/reducers/DeepviewReducer';
import Schedule from '../main/reducers/ScheduleReducer';
import LinkCreator from '../main/reducers/LinkCreatorReducer';
import CsvExport from '../main/reducers/CsvExport';
import TuneCustomExport from '../main/reducers/CustomExportReducer/TuneCustomExportReducer';
import BranchCustomExport from '../main/reducers/CustomExportReducer/BranchCustomExportReducer';
import Org from '../common/reducers/OrgReducer';
import Payments from '../main/reducers/PaymentsReducer';
import PaymentMethods from '../main/reducers/PaymentMethodsReducer';
import PbaLiveview from '../main/reducers/PbaLiveviewReducer';
import SDKInfo from '../main/reducers/SDKInfoReducer';
import SSO from '../main/reducers/SsoReducer';
import Subscriptions from '../main/reducers/SubscriptionsReducer';
import Team from '../main/reducers/TeamReducer';
import ThirdPartyGlobalSettings from '../main/reducers/ThirdPartyGlobalSettingsReducer';
import ThirdPartyProviderConfig from '../main/reducers/ThirdPartyProviderConfigReducer';
import Webhooks from '../main/reducers/WebhooksReducer';
import AppleSearchAds from '../main/reducers/AppleSearchAdsReducer';
import Snap from '../main/reducers/SnapReducer';
import Pinterest from './domains/AdPartner/Pinterest/Pinterest.reducer';
import Criteo from './domains/AdPartner/Criteo/Criteo.reducer';
import Twitter from '../main/reducers/TwitterReducer';
import Tiktok from './domains/AdPartner/TikTok/TikTok.reducer';
import TiktokSAN from './domains/AdPartner/TikTokSAN/TikTokSAN.reducer';
import Fraud from '../main/reducers/FraudReducer';
import FraudFighter from '../main/reducers/FraudFighterReducer';
import MicroFrontends from '../main/reducers/MicroFrontendsReducer';
import Activity from '../main/reducers/ActivityReducer';
import LogoutModal from '../main/reducers/LogoutModalReducer';
import PersonaServiceReducer from '../main/reducers/PersonaServiceReducer';
import WhitelistedDeviceOrmReducer from '../main/reducers/WhitelistedDeviceOrmReducer';
import DiscoAds from '../main/reducers/DiscoAdsReducer';
import Audience from '../main/reducers/AudienceReducer';
import SKAdnetwork from './domains/SKAdNetwork/SKAdNetwork.reducer';
import UserEntityTerms from '../common/reducers/UserEntityTermsReducer';
import AppStoreVerification from '../main/reducers/AppStoreVerificationReducer';
import QuickLinkTemplateReducer from '../main/reducers/QuickLinkTemplateReducer';
import LinkByQueryReducer from '../main/reducers/LinkManager/LinkByQueryReducer';
import EventsReducer from '../main/reducers/Events/EventsReducer';
import PrebuiltMacrosReducer from '../main/reducers/PrebuiltMacros/PrebuiltMacrosReducer';
import AlertNotificationsReducer from '../main/reducers/AlertNotificationsReducer';
import CustomCalculationReducer from '../main/reducers/CustomCalculationReducer';
import CreationDialogReducer from '../main/reducers/LinkManager/CreationDialogReducer';
import QuickLinkCreatorReducer from '../main/reducers/QuickLinkCreatorReducer/QuickLinkCreatorReducer';
import LinkHubCreatorReducer from './domains/LinkHubCreator/LinkHubCreator.reducer';
import LinkHubCustomerReducer from './domains/LinkHubCustomer/LinkHubCustomer.reducer';
import UsageReducer from './domains/Usage/Usage.reducer';
import StatusReducer from '../main/reducers/StatusReducer';
import AdLinkTemplateReducer from '../main/reducers/AdLinkTemplateReducer/AdLinkTemplateReducer';
import AppCategoryReducer from '../main/reducers/AppCategoryReducer';
import SKANConversionValueMappingReducer from './domains/SKANConversionValueMapping/SKANPostbacksConversionMapping.reducer';
import UserOnboardingDataReducer from '../common/reducers/UserOnboardingDataReducer';
import DruidReducer from '../common/reducers/DruidReducer';
import HealthCheckReducer from '../main/reducers/HealthCheckReducer';
import OnboardingLinkReducer from '../common/reducers/OnboardingLinkReducer';
import QuickLinksReducer from '../main/reducers/QuickLinksReducer';
import ShareableReducer from '../common/reducers/ShareableReducer';
import UserReducer from '../common/reducers/UserReducer';
import StartReducer from '../start/reducers/StartReducer';
import TwilioStartReducers from '../start/reducers/TwilioStartReducers';
import QrCodeLinkCreatorReducer from './domains/QrCodeLinkCreator/QrCodeLinkCreator.reducer';
import QrCodeLinkManagerFilterReducer from './domains/QrCodeLinkManagerFilter/QrCodeLinkManagerFilter.reducer';
import AdLinkCreatorReducer from './domains/AdLinkCreator/AdLinkCreator.reducer';
import FileIngestorReducer from './domains/FileIngestor/FileIngestor.reducer';

export const reducers = {
  accessControl: AccessControl,
  activity: Activity,
  ad_links: AdLinks,
  ad_partner: AdPartner,
  adLinkCreator: AdLinkCreatorReducer,
  ad_link_templates: AdLinkTemplateReducer,
  agencyRelationship: AgencyRelationshipReducer,
  alertNotifications: AlertNotificationsReducer,
  app: AppReducer,
  app_status: StatusReducer,
  app_category: AppCategoryReducer,
  appStore: AppStoreReducer,
  appStoreVerification: AppStoreVerification,
  apple_search_ads: AppleSearchAds,
  audience: Audience,
  auth_service: AuthServiceReducer,
  billing_account: BillingAccount,
  branchAccount: BranchAccountReducer,
  branchCustomExport: BranchCustomExport,
  cnames: Cnames,
  collection: Collection,
  creationDialog: CreationDialogReducer,
  csvExport: CsvExport,
  customCalculations: CustomCalculationReducer,
  dataIntegrations: DataIntegrations,
  deepview: Deepview,
  disco_ads: DiscoAds,
  domainLinks: DomainLinks,
  druid: DruidReducer,
  emailOnboarding: EmailOnboarding,
  events: EventsReducer,
  facebook: Facebook,
  fileIngestor: FileIngestorReducer,
  flipper_updates: FlipperUpdates,
  fraud: Fraud,
  fraud_fighter: FraudFighter,
  google: Google,
  google_ads: GoogleAds,
  google_marketing_platform: GoogleMarketingPlatform,
  health_checks: HealthCheckReducer,
  invoices: Invoices,
  journey: JourneyReducer,
  link_by_query: LinkByQueryReducer,
  linkCreator: LinkCreator,
  linkHubCreator: LinkHubCreatorReducer,
  linkHubCustomer: LinkHubCustomerReducer,
  logout_modal: LogoutModal,
  micro_frontends: MicroFrontends,
  ob_link: OnboardingLinkReducer,
  onboarding: StartReducer,
  org: Org,
  payments: Payments,
  payment_methods: PaymentMethods,
  persona_service: PersonaServiceReducer,
  pba_liveview: PbaLiveview,
  prebuiltMacros: PrebuiltMacrosReducer,
  qrCodeLinkCreator: QrCodeLinkCreatorReducer,
  qrCodeLinkManagerFilter: QrCodeLinkManagerFilterReducer,
  quickLinkCreator: QuickLinkCreatorReducer,
  quick_link_templates: QuickLinkTemplateReducer,
  quick_links: QuickLinksReducer,
  schedule: Schedule,
  sdk_info: SDKInfo,
  shareable: ShareableReducer,
  skadnetwork: SKAdnetwork,
  skan_conversion_value_mapping: SKANConversionValueMappingReducer,
  snap: Snap,
  pinterest: Pinterest,
  criteo: Criteo,
  sso: SSO,
  subscriptions: Subscriptions,
  team: Team,
  third_party_global_settings: ThirdPartyGlobalSettings,
  third_party_provider_config: ThirdPartyProviderConfig,
  tiktok: Tiktok,
  tiktok_san: TiktokSAN,
  tuneCustomExport: TuneCustomExport,
  twilio: TwilioStartReducers,
  twitter: Twitter,
  usage: UsageReducer,
  user: UserReducer,
  userEntityTerms: UserEntityTerms,
  userOnboardingData: UserOnboardingDataReducer,
  webhook: Webhooks,
  whitelist_devices: WhitelistedDeviceOrmReducer,
};

const app = combineReducers(reducers);

const composeEnhancers =
  process.env.NODE_ENV != 'production' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: 'Dashboard',
      })
    : compose;

const getMiddlewares = () => {
  return [thunk];
};

const enhancer = composeEnhancers(applyMiddleware(...getMiddlewares()));

const store = createStore(app, enhancer);

dashApiInterceptorSetup(store);
serverReduxSetup(store);

export default store;
